import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { connect, ConnectedProps } from "react-redux";
import { hideDialog } from "../data/dialog";
import MobileTerminalCallForm from "./Forms/MobileTerminalCall";
import MobileTerminalCallCompletionForm from "./Forms/MobileTerminalCallCompletion";
import TerminalCallContainerPlanning from "./Dialogs/TerminalCallContainerPlanning";

const mapStateToProps = (state) => ({
   dialog: state.dialog.dialog,
});

const mapDispatchToProps = {
  dispatchHideDialog: hideDialog,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type DialogOverlayProps = ConnectedProps<typeof connector>;

const DialogOverlay = ({ dialog, dispatchHideDialog }: DialogOverlayProps) => {
  const isOpen = Boolean(dialog);

  const handleClose = () => {
    dispatchHideDialog();
  };

  const renderContent = () => {
    switch (dialog?.content) {
      case 'terminalcallform': return <MobileTerminalCallForm {...dialog.dialogProps}/>;
      case "terminalcallcompletion": return <MobileTerminalCallCompletionForm {...dialog.dialogProps}/>;
      case "terminalcallcontainerplanning": return <TerminalCallContainerPlanning {...dialog.dialogProps}/>;
      default:
        return null;
    };
  }


  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth fullScreen={dialog?.fullScreen ?? true}>
      {dialog && (
        <>
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6">{dialog.title}</Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers>{renderContent()}</DialogContent>
          {dialog.actions && (
            <DialogActions>{dialog.actions}</DialogActions>
          )}
        </>
      )}
    </Dialog>
  );
};

export default connector(DialogOverlay);
